import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const PdfThumbnail = ({ file }) => {
  return (
    <div className="h-40 bg-black rounded-lg overflow-hidden mb-4 flex items-center justify-center">
      <Document file={file} loading="Loading PDF...">
        <Page pageNumber={1} width={240} />
      </Document>
    </div>
  );
};

export default PdfThumbnail;
